// UI5 Web Components used
import '@ui5/webcomponents/dist/RangeSlider.js';

import {CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {environment} from '../environments/environment';
import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule} from 'ngx-toastr';
import {ProjectServiceMock} from './services/mock/project.service.mock';
import {ProjectReferenceListComponent} from './pages/project-reference-list/project-reference-list.component';
import {ProjectModalComponent} from './components/project-modal/project-modal.component';
import {ProjectReferenceServiceImpl} from './services/project-reference.service';
import {ProjectReferenceServiceMock} from './services/mock/project-reference.service.mock';
import {MsalModule, MsalRedirectComponent} from '@azure/msal-angular';
import {BrowserCacheLocation, InteractionType, PublicClientApplication} from '@azure/msal-browser';
import {MsalIdTokenInterceptor} from './interceptor/msal-id-token.interceptor';
import {ProjectServiceImpl} from './services/project.service';
import {AuthServiceImpl} from './services/auth.service';
import {AuthServiceMock} from './services/mock/auth.service.mock';
import {GraphServiceImpl} from './services/graph.service';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {GraphServiceMock} from './services/mock/graph.service.mock';
import {ProjectReferenceDetailComponent} from './pages/project-reference-detail/project-reference-detail.component';
import {PrdHeaderComponent} from './components/project-reference-detail/header/prd-header.component';
import {PrdJumbotronComponent} from './components/project-reference-detail/jumbotron/prd-jumbotron.component';
import {PrdDescriptionComponent} from './components/project-reference-detail/description/prd-description.component';
import {PrdPropertiesComponent} from './components/project-reference-detail/properties/prd-properties.component';
import {ButtonComponent} from './components/button/button.component';
import {BadgeComponent} from './components/badge/badge.component';
import {IconChevronLeftComponent} from './components/icon-chevron-left/icon-chevron-left.component';
import {MiniMapComponent} from './components/project-reference-detail/mini-map/mini-map.component';
import {ObjectToMapPipe} from './pipes/properties-to-map.pipe';
import {DateInterceptor} from './interceptor/date-interceptor.service';
import {FileUploadButtonComponent} from './components/file-upload-button/file-upload-button.component';
import {PrdPhotosComponent} from './components/project-reference-detail/photos/prd-photos.component';
import {FileUploadDndAreaComponent} from './components/file-upload-dnd-area/file-upload-dnd-area.component';
import {PrdPhotoComponent} from './components/project-reference-detail/photo/prd-photo.component';
import {ProjectReferencePhotoServiceImpl} from './services/project-reference-photo.service';
import {ProjectReferencePhotoServiceMock} from './services/mock/project-reference-photo.service.mock';
import {IconCloseComponent} from './components/icon-close/icon-close.component';
import {PrdTeamMembersComponent} from './components/project-reference-detail/team-members/prd-team-members.component';
import {TeamMemberServiceImpl} from './services/team-member.service';
import {TeamMemberServiceMock} from './services/mock/team-member.service.mock';
import {TeamMemberModalComponent} from './components/project-reference-detail/team-member-modal/team-member-modal.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {PhotoComponent} from './components/photo/photo.component';
import {FocusPointModalComponent} from './components/focus-point-modal/focus-point-modal.component';
import {ImagePipe} from './pipes/image.pipe';
import {SearchFilterComponent} from './components/search-filter/search-filter.component';
import {SearchFilterGroupSimpleComponent} from './components/search-filter-group-simple/search-filter-group-simple.component';
import {LinkServiceImpl} from './services/link.service';
import {LinkServiceMock} from './services/mock/link.service.mock';
import {ProjectReferenceGridComponent} from './components/project-reference-grid/project-reference-grid.component';
import {ProjectReferenceGridItemComponent} from './components/project-reference-grid-item/project-reference-grid-item.component';
import {NavigateBackDirective} from './directives/navigate-back.directive';
import {ProjectReferenceTableComponent} from './components/project-reference-table/project-reference-table.component';
import {HasRoleDirective} from './directives/has-role.directive';
import {StatusTranslatePipe} from './pipes/status-translate.pipe';
import {ProjectRelationServiceImpl} from './services/project-relation.service';
import {ProjectRelationServiceMock} from './services/mock/project-relation.service.mock';
import {PrdRelationModalComponent} from './components/project-reference-detail/relation-modal/prd-relation-modal.component';
import {PrdRelationsComponent} from './components/project-reference-detail/relations/prd-relations.component';
import {RelationRoleSelectComponent} from './components/item-select/relation-role-select.component';
import {MdmCompanySelectComponent} from './components/item-select/mdm-company-select.component';
import {PhoneNumberFormatPipe} from './pipes/phone-number-format.pipe';
import {PostalCodeFormatPipe} from './pipes/postal-code-format.pipe';
import {AddButtonComponent} from './components/add-button/add-button.component';
import {Nl2brPipe} from './pipes/nl2br.pipe';
import {ThrottledClickDirective} from './directives/throttled-click.directive';
import {CustomCompanySelectComponent} from './components/item-select/custom-company-select.component';
import {OverflowContentComponent} from './components/overflow-content/overflow-content.component';
import {PrdLinksComponent} from './components/project-reference-detail/links/prd-links.component';
import {LinkModalComponent} from './components/project-reference-detail/link-modal/link-modal.component';
import {LightboxModalComponent} from './components/lightbox-modal/lightbox-modal.component';
import {LinkTypeSelectComponent} from './components/item-select/link-type-select.component';
import {PrdAttributesComponent} from './components/project-reference-detail/attributes/prd-attributes.component';
import {ProjectReferenceAttributeServiceImpl} from './services/project-reference-attribute.service';
import {ProjectReferenceAttributeServiceMock} from './services/mock/project-reference-attribute.service.mock';
import {AttributeValuePipe} from './pipes/attribute-value.pipe';
import {AttributeKeyTranslatePipe} from './pipes/attribute-key-translate.pipe';
import {AttributeEditableComponent} from './components/attribute-editable/attribute-editable.component';
import {OutsideClickDirective} from './directives/outside-click.directive';
import {AttributeReadonlyComponent} from './components/attribute-readonly/attribute-readonly.component';
import {ThousandSeparatorPipe} from './pipes/thousand-separator.pipe';
import {PrdContractAttributesComponent} from './components/project-reference-detail/contract-attributes/prd-contract-attributes.component';
import {ProjectReferenceContractAttributesServiceImpl} from './services/project-reference-contract-attributes.service';
import {ProjectReferenceContractAttributesServiceMock} from './services/mock/project-reference-contract-attributes.mock';
import {AttributeProjectEditableComponent} from './components/attribute-project-editable/attribute-project-editable.component';
import {SortableDirective} from './directives/sortable.directive';
import {SearchFilterGroupRangeComponent} from './components/search-filter-group-range/search-filter-group-range.component';
import {ProjectReferencePrintComponent} from './components/project-reference-print/project-reference-print.component';
import {ProjectReferenceDownloadModalComponent} from './components/project-reference-download-modal/project-reference-download-modal.component';
import {PrintLogoCompanyComponent} from './components/project-reference-print/print-logo-company/print-logo-company.component';
import {PhotoDownloadServiceImpl} from './services/photo-download.service';
import {PhotoDownloadServiceMock} from './services/mock/photo-download.service.mock';
import {BlobDownloadServiceImpl} from './services/blob-download.service';
import {BlobDownloadServiceMock} from './services/mock/blob-download.service.mock';
import localeNL from '@angular/common/locales/nl';
import {registerLocaleData} from '@angular/common';
import {LocationStreetFormatPipe} from './pipes/location-street-format.pipe';
import {CopyToClipboardComponent} from './components/copy-to-clipboard/copy-to-clipboard.component';
import {ClipboardFormatRelationAddressPipe} from './pipes/clipboard-format-relation-address.pipe';
import {ContractAttributeValuePipe} from './pipes/contract-attribute-value.pipe';
import {TeamMemberRoleTranslatePipe} from './pipes/team-member-role-translate.pipe';
import {ImageFadeDirective} from './directives/image-fade.directive';
import {BypassSecurityPipe} from './directives/bypass-security.directive';
import {isInIframe} from './utils/window';
import {LoginPageComponent} from './pages/login-page/login-page.component';
import {ProjectReferenceCarouselComponent} from './components/project-reference-carousel/project-reference-carousel.component';
import {ColorSchemePickerComponent} from './components/color-scheme-picker/color-scheme-picker.component';
import {ColorSchemeOptionComponent} from './components/color-scheme-option/color-scheme-option.component';
import {ColorSchemeServiceImpl} from './services/color-scheme.service';
import {ColorSchemeServiceMock} from './services/mock/color-scheme.mock';
import {ProjectReferenceCarouselPageComponent} from './components/project-reference-carousel-page/project-reference-carousel-page.component';
import {HasRoleAndKvwNumberDirective} from './directives/has-role-and-kvw-number.directive';
import { ProjectReferenceDownloadSelectInfoModalComponent } from './components/project-reference-download-select-info-modal/project-reference-download-select-info-modal.component';
import { SelectPhotoLayoutComponent } from './components/project-reference-download-select-info-modal/select-photo-layout/select-photo-layout.component';
import { SelectPhotosComponent } from './components/project-reference-download-select-info-modal/select-photos/select-photos.component';
import { VwuiAngularModule } from '@bvgo-ict/vwui-angular'

registerLocaleData(localeNL, 'nl');

export function serviceWithMock(provide: string, serviceRef: any, mock: any): any {
    return {
        useClass: environment.useMock ? mock : serviceRef,
        provide
    };
}

@NgModule({ declarations: [
        AppComponent,
        ProjectReferenceListComponent,
        ProjectModalComponent,
        ProjectReferenceDetailComponent,
        PrdHeaderComponent,
        PrdJumbotronComponent,
        PrdDescriptionComponent,
        PrdPropertiesComponent,
        ButtonComponent,
        BadgeComponent,
        IconChevronLeftComponent,
        IconCloseComponent,
        MiniMapComponent,
        ObjectToMapPipe,
        ImagePipe,
        SearchFilterComponent,
        SearchFilterGroupSimpleComponent,
        ObjectToMapPipe,
        FileUploadButtonComponent,
        PrdPhotosComponent,
        FileUploadDndAreaComponent,
        PrdPhotoComponent,
        ProjectReferenceGridComponent,
        ProjectReferenceGridItemComponent,
        NavigateBackDirective,
        ProjectReferenceTableComponent,
        HasRoleDirective,
        HasRoleAndKvwNumberDirective,
        StatusTranslatePipe,
        PhotoComponent,
        FocusPointModalComponent,
        PrdTeamMembersComponent,
        TeamMemberModalComponent,
        PrdRelationModalComponent,
        PrdRelationsComponent,
        RelationRoleSelectComponent,
        MdmCompanySelectComponent,
        PhoneNumberFormatPipe,
        PostalCodeFormatPipe,
        AddButtonComponent,
        Nl2brPipe,
        OverflowContentComponent,
        PrdLinksComponent,
        LinkModalComponent,
        ThrottledClickDirective,
        CustomCompanySelectComponent,
        LightboxModalComponent,
        CustomCompanySelectComponent,
        LinkTypeSelectComponent,
        PrdAttributesComponent,
        AttributeValuePipe,
        AttributeKeyTranslatePipe,
        AttributeEditableComponent,
        OutsideClickDirective,
        AttributeReadonlyComponent,
        ThousandSeparatorPipe,
        PrdContractAttributesComponent,
        AttributeProjectEditableComponent,
        SearchFilterGroupRangeComponent,
        ProjectReferencePrintComponent,
        ProjectReferenceDownloadModalComponent,
        PrintLogoCompanyComponent,
        LocationStreetFormatPipe,
        CopyToClipboardComponent,
        ClipboardFormatRelationAddressPipe,
        ContractAttributeValuePipe,
        TeamMemberRoleTranslatePipe,
        ImageFadeDirective,
        BypassSecurityPipe,
        LoginPageComponent,
        ProjectReferenceCarouselComponent,
        ColorSchemePickerComponent,
        ColorSchemeOptionComponent,
        ProjectReferenceCarouselPageComponent,
        ProjectReferenceDownloadSelectInfoModalComponent,
        SelectPhotoLayoutComponent,
        SelectPhotosComponent,
        SortableDirective
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent, MsalRedirectComponent], imports: [BrowserModule,
        AppRoutingModule,
        InfiniteScrollModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        environment.useMock ? NoopAnimationsModule : BrowserAnimationsModule,
        VwuiAngularModule.forRoot(),
        ToastrModule.forRoot({
            timeOut: environment.useMock ? 1000 : 3000
        }),
        MsalModule.forRoot(new PublicClientApplication({
            auth: {
                clientId: environment.authClientId,
                authority: environment.authAuthority,
                redirectUri: '/',
                navigateToLoginRequestUrl: true
            },
            cache: {
                cacheLocation: BrowserCacheLocation.LocalStorage
            },
            system: {
                // IdToken expires too early, this works around that by making msal refresh the token earlier
                tokenRenewalOffsetSeconds: 1200
            }
        }), {
            interactionType: isInIframe() ? InteractionType.Popup : InteractionType.Redirect,
            loginFailedRoute: '/login'
        }, {
            interactionType: isInIframe() ? InteractionType.Popup : InteractionType.Redirect,
            protectedResourceMap: new Map()
        })], providers: [
        ThousandSeparatorPipe,
        PostalCodeFormatPipe,
        serviceWithMock('ProjectService', ProjectServiceImpl, ProjectServiceMock),
        serviceWithMock('AuthService', AuthServiceImpl, AuthServiceMock),
        serviceWithMock('ProjectReferenceService', ProjectReferenceServiceImpl, ProjectReferenceServiceMock),
        serviceWithMock('ProjectReferencePhotoService', ProjectReferencePhotoServiceImpl, ProjectReferencePhotoServiceMock),
        serviceWithMock('GraphService', GraphServiceImpl, GraphServiceMock),
        serviceWithMock('TeamMemberService', TeamMemberServiceImpl, TeamMemberServiceMock),
        serviceWithMock('LinkService', LinkServiceImpl, LinkServiceMock),
        serviceWithMock('ProjectRelationService', ProjectRelationServiceImpl, ProjectRelationServiceMock),
        serviceWithMock('ProjectReferenceAttributeService', ProjectReferenceAttributeServiceImpl, ProjectReferenceAttributeServiceMock),
        serviceWithMock('ProjectReferenceContractAttributesService', ProjectReferenceContractAttributesServiceImpl, ProjectReferenceContractAttributesServiceMock),
        serviceWithMock('PhotoDownloadService', PhotoDownloadServiceImpl, PhotoDownloadServiceMock),
        serviceWithMock('BlobDownloadService', BlobDownloadServiceImpl, BlobDownloadServiceMock),
        serviceWithMock('ColorSchemeService', ColorSchemeServiceImpl, ColorSchemeServiceMock),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalIdTokenInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DateInterceptor,
            multi: true
        },
        {
            provide: LOCALE_ID,
            useValue: 'nl'
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
